angular.module("tromanWeb").filter("duration", [function () {

    function pad(num) {
        return num < 10 ? "0" + num : "" + num;
    }

    return function (dur) {
        if (typeof dur !== 'number')
            throw "Expected number";
        if (dur < 0)
            return "";
        dur = Math.floor(dur / (1000 * 60));
        var mins = dur % 60;
        dur = Math.floor(dur / 60);
        var hours = dur % 24;
        dur = Math.floor(dur / 24);

        var time = pad(hours) + ":" + pad(mins);

        var days = dur;
        if (days === 1)
            return "1 dag, " + time;
        if (days > 0)
            return days + " dagar, " + time;
        return time;
    };
}]);
